var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPfButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69309 15L6.59532 12.7077C6.49845 12.637 6.47262 12.5146 6.53074 12.4171L6.75893 12.029C7.42197 10.9068 7.75779 9.6928 7.75779 8.42144C7.75779 7.42539 7.54682 6.45227 7.13134 5.52887L6.91393 5.04709C6.85365 4.91326 6.92684 4.76414 7.07753 4.71061L14.6551 2.01877C14.8037 1.96524 14.9737 2.03025 15.034 2.16216L15.2514 2.64394C16.0802 4.4831 16.5 6.42551 16.5 8.42144H14.7498C14.7498 6.88817 14.4743 5.38739 13.9296 3.95162L9.05158 5.68372C9.35727 6.56889 9.51226 7.48657 9.51226 8.41953C9.51226 9.71192 9.20658 10.9986 8.62319 12.1782L10.8168 13.8013L9.69309 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.57197C14.1357 4.99432 14.4573 6.47917 14.4573 8H16.5C16.5 6.28409 16.1282 4.60417 15.397 3L13.5 3.57197Z",
    fill: "url(#paint0_linear_52_1733)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51424 12.5329L9.43998 15L10.5 13.714L8.46542 12L6.5 12.5206C6.5061 12.5247 6.51017 12.5288 6.51424 12.5329Z",
    fill: "url(#paint1_linear_52_1733)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6834 8C11.5485 8 11.4393 8.10448 11.4393 8.23366V8.77128C11.4393 12.0084 9.94665 14.9187 7.58461 16.9039C7.47147 16.9988 7.47147 17.1679 7.58659 17.261L13.454 21.9456C13.5532 22.0254 13.6981 22.0159 13.7874 21.9267L14.1507 21.5619C17.6005 18.0988 19.5 13.5566 19.5 8.77128V8.23366C19.5 8.10448 19.3908 8 19.2559 8H11.6834ZM13.4917 19.9643L9.77594 17.0007C11.7172 14.9244 12.8506 12.3256 13.0272 9.54445L17.8664 9.54635C17.6858 13.4065 16.1535 17.0577 13.4917 19.9643Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_1733",
    x1: 15.0019,
    y1: 11.9237,
    x2: 15.0019,
    y2: 4.70509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_1733",
    x1: 8.50251,
    y1: 17.3542,
    x2: 8.50251,
    y2: 13.0231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97A0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPfButton);
export default __webpack_public_path__ + "static/media/logo-pf-button.387abee9b981f64b6afb6ca67d9ceb31.svg";
export { ForwardRef as ReactComponent };